var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['radio', _vm.checked ? 'checked' : 'no-checked', _vm.disabled && 'disable-checked'],on:{"click":_vm.changeRadio}})
}
var staticRenderFns = []

export { render, staticRenderFns }